import styled from "styled-components";
import { withStyles } from "@mui/styles";
import { theme } from "../../config/theme";
import { AppBar, Chip, InputBase, TableBody, TableCell, TableContainer, TableRow, TextField } from "@mui/material";

export const StyledChip = styled(Chip)`
  height: 20px;
  margin: 1px 5px 1px 0;
  font-size: 12px;
  border-radius: 3px;

  & .MuiChip-deleteIcon {
    height: 15px;
  }
`;

export const StyledTextField = styled(TextField)`
  & .MuiInputBase-root {
    padding: 6px 12px;
    border-radius: 5px;
    min-height: 38px;
  }

  & .MuiOutlinedInput-input {
    height: 15px;
    padding: 0;
    font-size: 12px;
  }

  & fieldset {
    border: 1px solid #e2e2e2;
  }
`;

const StyledAppBar = styled(AppBar)`
  box-shadow: none;
  color: #000;
`;

const NoResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 35px;
  height: 100%;
  justify-content: center;

  h4 {
    font-size: 20px;
    font-weight: 300;
    text-align: center;
    line-height: 1.2;
    margin: 25px 0 0 0;
  }

  p {
    opacity: 0.5;
    font-size: 14px;
    margin: 0;
  }
`;

const EditButton = styled.span`
  font-weight: 600;
  color: #45a09d;
  cursor: pointer;
`;
const Label = styled.div`
  color: #313737;
  font-size: 14px;
  font-weight: 600;
`;
const Mono = styled.span`
  color: #484848;
  opacity: 0.6;
  margin-right: 3px;
`;

const RowDetail = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 2px solid #607d8b;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;

  .primary {
    color: #484848;
    font-size: 14px;
    font-weight: bold;
  }

  .secondary {
    color: #0366d6;
    font-weight: 700;
    cursor: pointer;

    .internal-flag {
      color: #adadad;
      font-size: 7px;
      svg {
        position: relative;
        width: 15px;
        top: 6px;
        left: 3px;
      }
    }
  }
`;

const DataBlock = styled.div`
  width: 300px;

  &.short {
    width: 200px;
  }

  .header {
    color: #313737;
    font-size: 14px;
    font-weight: 600;
  }

  .row {
    display: flex;
    flex-direction: row;
  }

  .label {
    color: #777777;
    width: 80px;
    margin-right: 5px;
  }

  .label.long {
    width: 150px;
  }

  .value {
    color: #484848;
    overflow-wrap: anywhere;
  }
`;

const Meta = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px 20px;
  justify-content: space-between;
`;

const OverflowText = styled.div`
  overflow-x: auto;
  width: 900px;
  max-height: 300px;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
`;

const LoadMore = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  background: #e7f1fe;
  color: #4384f4;
  width: 100%;
  padding: 5px;

  img {
    padding-right: 8px;
  }
`;

//---FilterBar->
const FilterBarContainer = styled.div`
  background: white;
  display: flex;
  width: 1080px;
  margin: auto;
  margin-bottom: 15px;
  flex-direction: column;
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 #dce1e6;
  padding: 15px;
  position: relative;
  transition: min-height 0.3s ease-out; // note that we're transitioning max-height, not height!
  min-height: 100px;
  * {
    box-sizing: border-box;
  }

  .filter-btn {
    right: 30px;
    top: 44px;
    position: absolute;

    height: 35px;
    border: none;
    padding: 0px 10px;
    font-size: 12px;
    font-weight: 600;
    margin-right: -10px;
    border-radius: 3px;
    color: #fff;
    background-color: #45a09d;
    cursor: pointer;
    outline: none;
  }
`;

const OtherFilters = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  .filter {
    display: flex;
    flex-direction: column;
    margin-right: 8px;
    height: 80px;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
  }

  .filter-label {
    font-weight: 600;
    margin-right: 20px;
    padding-bottom: 5px;
  }
`;

const AdvancedToggleBtn = styled.button`
  margin-top: 12px;
  margin-left: -5px;
  height: 35px;
  border-radius: 3px;
  outline: none;
  cursor: pointer;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  color: #8a94a1;
  box-shadow: ${(props) => (props.toggled ? "inset 0px 0px 0px 1px #45A09D" : null)};

  border: ${(props) => (props.toggled ? "1px solid #45A09D;" : "1px solid #d3d7db")};
`;

const PillDate = styled.div`
  box-shadow:
    0 0.105em 0.213em rgba(50, 50, 93, 0.07),
    0 0.063em 0.125em rgba(0, 0, 0, 0);
  font-size: 12px;
  color: #3a4454;
  padding: 5px 10px;
  margin-right: 10px;
  border-radius: 3px;
  cursor: pointer;
  background: #f9fafb;
  border: 1px solid #d3d7db;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 35px;

  svg {
    width: 15px;
    opacity: 0.5;
    margin-right: 5px;
    margin-top: -2px;
  }
`;

const PillContainer = styled.div`
  position: relative;
`;

const SearchBox = styled.div`
  display: flex;
  border: 1px solid #e2e2e2;
  flex-direction: row;
  align-items: center;
  border-radius: 3px;
  height: 35px;
  padding: 10px;
  position: relative;
  width: ${(props) => (props.widthSize === "large" ? "325px" : "180px")};
  margin-bottom: 8px;

  .search-icon {
    position: relative;
    top: 3px;
    left: -5px;
    opacity: 0.5;
  }
`;

const TextInput = styled(InputBase)`
  font-size: 12px;
  position: relative;
  width: 100%;
  height: 40px;
`;

const RequestIdChipContainer = styled.div`
  width: 500px;
  display: contents;

  .filter-label {
    font-weight: 600;
    margin-right: 20px;
    padding-bottom: 5px;
  }
`;

const RequestIdChipStyles = {
  input: {
    height: "15px ",
    padding: "0 ",
    fontSize: "12px"
  },
  chip: {
    "height": "20px ",
    "margin": "1px 5px 1px 0",
    "fontSize": "12px",
    "borderRadius": "3px",
    "& > svg": {
      height: "15px"
    }
  },
  chipContainer: {
    margin: "0 0 0 0"
  },
  inputRoot: {
    "padding": "3px 12px ",
    "borderRadius": "5px",
    "& > fieldset": {
      border: "1px solid #e2e2e2 "
    }
  },
  root: {
    display: "contents",
    border: 0
  }
};

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;

  .row {
    width: 100%;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #e0e0e0;
    padding: 10px 20px;
  }
`;

const StyledTableBody = styled(TableBody)``;

const auditLogsStyles = () => ({
  paper: {
    width: 1080,
    margin: "auto auto 4px",
    overflow: "auto",
    boxShadow: "0 1px 3px 0 #dce1e6",
    borderRadius: "5px"
  }
});

const StyledTableContainer = styled(TableContainer)`
  max-height: calc(100vh - 270px - 5px);
`;

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: theme.palette.common.white,
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "0",
    color: "rgba(0,0,0,.6)"
  },
  body: {
    fontSize: 13,
    border: "0px solid white"
  }
}))(TableCell);

const NoMarginRow = styled(TableRow)`
  margin: 0;
  padding: 0;
`;

const StyledTableRow = withStyles(() => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

const SecondaryBar = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 13px;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    border: 1px solid rgba(0, 0, 0, 0);
    padding: 0px 10px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 3px;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    color: rgba(0, 0, 0, 0.6);
    box-shadow:
      0 0.105em 0.213em rgba(50, 50, 93, 0.14),
      0 0.063em 0.125em rgba(0, 0, 0, 0);

    & > svg {
      height: 17px;
      margin-left: -8px;
    }

    .loader {
      margin-right: 5px;
    }

    &:disabled {
      background: #f5f5f5;
    }
  }
`;

export {
  StyledAppBar,
  NoResultsContainer,
  EditButton,
  Label,
  Mono,
  RowDetail,
  Column,
  DataBlock,
  Meta,
  OverflowText,
  LoadMore,
  FilterBarContainer,
  OtherFilters,
  AdvancedToggleBtn,
  PillDate,
  PillContainer,
  SearchBox,
  SecondaryBar,
  TextInput,
  RequestIdChipContainer,
  RequestIdChipStyles,
  LoadingContainer,
  StyledTableBody,
  auditLogsStyles,
  StyledTableContainer,
  StyledTableCell,
  NoMarginRow,
  StyledTableRow
};
